/* eslint-disable jira/filename-case */

import { metrics } from '@atlassian/browser-metrics/factory';
import type { Metric } from '@atlassian/browser-metrics/metric';

export const globalIssueCreateModalLoad: Metric = metrics.interaction({
	key: 'global-issue-create-modal',
});

export const globalIssueCreateModalLoadSubsequent: Metric = metrics.interaction({
	key: 'global-issue-create-modal-subsequent',
});

export const successFlagDisplay: Metric = metrics.interaction({
	key: 'global-issue-create-dynamic-success-flag-display',
});

export const successFlagAddToSprintAction: Metric = metrics.interaction({
	key: 'global-issue-create-dynamic-success-flag-add-to-sprint-action',
});

export const successFlagClearFiltersAction: Metric = metrics.interaction({
	key: 'global-issue-create-dynamic-success-flag-clear-filters-action',
});
